import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React, { useEffect } from 'react';

import { InputMoney } from '../../../../../../../../../components/InputMoney';
import { ResponsiveSuccessIconButton } from '../../../../../../../../../components/ResponsiveSuccessIconButton';
import { RiskRating } from '../../../../../../../../../components/RiskRating';
import {
  TableContentItemCaptions,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { useFundsAssetController } from '../../../../../hooks/products/Funds';
import { LateralBar } from '../../../components/LateralBar';

import { FundsItemSelectedTypes } from '.';

export const FundsItemSelectedTablet: React.FC<FundsItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
}) => {
  const id = offer.productIdNormalized;
  const {
    control,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    isFocused,
    currentValueFormatted,
    currentValue,
  } = useFundsAssetController(offer);

  useEffect(() => {
    if (offer.orderValue === currentValue) {
      return;
    }
    const updatedOffer = { ...offer, orderValue: currentValue || 0 };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  return (
    <Box p="inline.xxs">
      <LateralBar
        backgroundColor={Color['product.fundos']}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack flex={1} space="inline.xxxs">
        <HStack flex={1} justifyContent="space-between">
          <UI.ListItem testId="selected-product-name" title="Produto" stackProps={{ maxW: '1/6' }}>
            <VStack maxW="100%" pr={Spacing['inline.xxxs']} space={Spacing['stack.quarck']}>
              <TableContentItemText noOfLines={2}>
                {offer.productNameNormalized}
              </TableContentItemText>
              <TableContentItemCaptions icons={offer.captions} />
            </VStack>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-category" title="Tipo">
            <TableContentItemText>{offer.productCategoryNormalized}</TableContentItemText>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-profitabilityTwelveMonths" title="Rent. 12 meses">
            <TableContentItemText>{offer.profitabilityTwelveMonthsNormalized}</TableContentItemText>
          </UI.ListItem>
          <UI.ListItem
            testId="selected-product-administrationFee"
            title="Taxa admin."
            stackProps={{ maxW: '14%' }}>
            <Stack maxW="100%">
              <TableContentItemText tooltip={offer.administrationFeeNormalized}>
                {offer.administrationFeeNormalized}
              </TableContentItemText>
            </Stack>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-risk" title="Risco">
            <RiskRating
              currentRiskRating={Number(offer.riskRatingLevelNormalized) || 0}
              tooltip={offer.riskRatingNormalized || ''}
            />
          </UI.ListItem>
          <UI.ListItem testId="selected-product-name" title="Aplicação mínima">
            <TableContentItemText>
              {Utils.Mask.Money(offer.applicationMinimumAmount)}
            </TableContentItemText>
          </UI.ListItem>
        </HStack>
        <HStack flex={1} flexGrow={1} space="inline.xxxs" alignItems="flex-end">
          <UI.ListItem
            testId="selected-product-name"
            title="Valor aplicado"
            stackProps={{ flexGrow: 1 }}>
            <Stack flexGrow={1} w="full">
              <InputMoney
                id={`fixedIncome-input${id}`}
                name="createAppliedAmount"
                control={control}
                handleFocus={handleInputFocus}
                handleBlur={handleInputBlur}
                handleSubmit={handleSubmit}
                handleClear={handleInputClear}
                currentValue={currentValueFormatted}
                hasFocus={isFocused}
                minValue={offer.applicationMinimumAmount || 0}
                customInputProps={{
                  ...{ ...(isFocused && hasError && { error: hasError }) },
                  ...{ ...(isFocused && !hasError && { helpText }) },
                }}
              />
            </Stack>
          </UI.ListItem>
          <ResponsiveSuccessIconButton />
        </HStack>
      </VStack>
    </Box>
  );
};
